export default (function () {
    const socialLinks = {
        initViberBtn() {
            $('.js--share-with-viber').click(function (e) {
                e.preventDefault();
                const location = window.location.href;
                document.location.href = `viber://forward?text=${location}`;
            });
        },
    };
    
    $(document).ready(() => {
        socialLinks.initViberBtn();
    });
}());
